import Head from 'next/head'
import styles from '@/styles/About.module.css'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

const ExtraSection = dynamic(() => import('../components/ExtraSection'))

const more = () => {
  const { t } = useTranslation()
  const [itemListForJson, setItemListForJson] = useState([])

  useEffect(() => {
    const generateMissingImage = (width, height, alt) => {
      if (
        !width ||
        !height ||
        typeof width !== 'number' ||
        typeof height !== 'number'
      ) {
        return '' // or some default image URL
      }
      return (
        <Image
          src={`https://via.placeholder.com/${width}x${height}`}
          width={width}
          height={height}
          alt={alt || 'Image Not Available'}
          loading='lazy'
        />
      )
    }

    // Define itemListElement and itemListForJson arrays within the component function
    const itemListElement = [
      {
        name: t('Fries Plate'),
        image: generateMissingImage(400, 300),
        description: t(
          'Crispy fries served with your choice of dipping sauce.'
        ),
        recipeIngredient: [t('Fries Plate')],
      },
      {
        name: t('Mozzarella sticks'),
        image: generateMissingImage(400, 300),
        description: t(
          'Delicious mozzarella sticks, deep-fried to golden perfection.'
        ),
        recipeIngredient: [
          t('Mozzarella sticks'),
          t('crisp vegetables'),
          t('flavorful dressing'),
        ],
      },
      {
        name: t('Dirty Fries'),
        image: generateMissingImage(400, 300),
        description: t(
          'Indulge in a savory combination of crispy fries topped with melted cheese, jalapenos, and tangy sauce.'
        ),
        recipeIngredient: [t('Dirty Fries')],
      },
      {
        name: t('Chilli cheese'),
        image: generateMissingImage(400, 300),
        description: t(
          'Spicy chili cheese bites, perfect for sharing or as a hearty appetizer.'
        ),
        recipeIngredient: [t('Chilli cheese 6st')],
      },
      {
        name: t('Crispy chicken'),
        image: generateMissingImage(400, 300),
        description: t(
          'Crispy breaded chicken pieces, served with your choice of dipping sauce.'
        ),
        recipeIngredient: [t('Crispy chicken 6st')],
      },
      {
        name: t('Chicken wings'),
        image: generateMissingImage(400, 300),
        description: t(
          'Juicy chicken wings, seasoned and baked to perfection.'
        ),
        recipeIngredient: [t('Chicken wings 6st')],
      },
      {
        name: t('Onion rings'),
        image: generateMissingImage(400, 300),
        description: t(
          'Crispy battered onion rings, served with a tangy dipping sauce.'
        ),
        recipeIngredient: [t('Onion rings 6st')],
      },
      // Add more items here with appropriate descriptions
    ]

    const itemListForJson = itemListElement.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Recipe',
        name: item.name,
        image: item.image,
        description: item.description,
        recipeIngredient: item.recipeIngredient,
      },
    }))

    setItemListForJson(itemListForJson)
  }, [t])

  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Övriga rätter Meny</title>
        <meta
          name='description'
          content='Unna dig en smakrik och uppfriskande förrätt som inleder din måltid på bästa sätt. Vår meny erbjuder en rik variation av förrätter, från klassiska favoriter till mer innovativa smaker. Varje förrätt är ett konstverk i sig och kommer att väcka dina smaklökar till liv.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ItemList',
              itemListElement: itemListForJson,
            }),
          }}
        ></script>
      </Head>
      <ExtraSection />
    </main>
  )
}

export default more
